import { styled } from '@linaria/react';
import { Flex } from '@vio/atlas/helpers/Flex';
import { Text } from '@vio/atlas/Text';
const _exp = /*#__PURE__*/() => Flex.Row;
export const TopSection = /*#__PURE__*/styled(_exp())({
  name: "TopSection",
  class: "td838v9",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => Text;
export const DateAndRoomsText = /*#__PURE__*/styled(_exp3())({
  name: "DateAndRoomsText",
  class: "d3yckha",
  propsAsIs: true
});
export const SeeAllText = /*#__PURE__*/styled('span')({
  name: "SeeAllText",
  class: "ss0g7xs",
  propsAsIs: false
});
export const TopSectionText = /*#__PURE__*/styled('div')({
  name: "TopSectionText",
  class: "t1ncjwhp",
  propsAsIs: false
});

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");